export default {"src":"/_next/static/media/car.43390390.svg","height":22,"width":25};